/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useCallback, useState, useEffect, ChangeEvent } from 'react';
import { CloseRounded, SearchRounded } from '@mui/icons-material';
import { useForm } from 'react-hook-form';
import dayjs from 'dayjs';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import {
  Avatar,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Radio,
  RadioGroup,
  SwipeableDrawer,
  TextField,
} from '@mui/material';
import _ from 'lodash';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';

import { Input } from '../../../../components/Input';
import { ConfirmModal } from '../../../../components/ConfirmModal';
import { LoadingBackdrop } from '../../../../components/LoadingBackdrop';
import { DrawerRequestSignaturesDoc } from '../../../../components/DrawerRequestSignatureDoc';

import {
  AmountSelectedUsers,
  ArchiveStyles,
  Container,
  FolderType,
  FolderTypeTitle,
  HeaderDrawer,
  SelectedAllBtn,
  TextBtn,
  Users,
} from './styles';

import { Guest } from '../../../../services/requests/usuarios/types';
import { Folder } from '../../../../services/requests/pastas/types';
import {
  createFolderRequest,
  getFoldersByFolderIdRequest,
  updateFolderRequest,
  removeFolderRequest,
  moveFolder,
} from '../../../../services/requests/pastas/utils';
import {
  getFileByIdRequest,
  getUsersByCompanyIdRequest,
  updateWithoutFileRequest,
  removeFileInFolderRequest,
} from '../../../../services';

import useAuthStore from '../../../../store/auth';
import useCompanyStore from '../../../../store/companies';

import { stringAvatar } from '../../../../utils/avatarGenerator';

import { MovingFile } from '../MovingFile';
import { DrawerSignatures } from '../Signatures';
import { FolderCard } from '../FolderCard';

dayjs().format();

interface Archives {
  name: string;
  type: string;
  created_at: string;
  link: string;
}

export interface ArchivesProps {
  id: string;
  name: string;
  creator: string;
  creator_data: string;
  config: any;
  archive: Archives[];
}

interface GuestToSelect extends Guest {
  selected: boolean;
}

interface Props {
  files: Folder[] | any;
  setFiles: (files: any[]) => void;
  onLoad: any;
  handleOpenFileViewer: any;
  isAutomatic?: boolean;
  isInFolder?: boolean;
}

export const Archives = ({
  files,
  setFiles,
  onLoad,
  handleOpenFileViewer,
  isAutomatic = false,
  isInFolder = false,
}: Props) => {
  const params = useParams();

  const user = useAuthStore(state => state.user);
  const selectedCompany = useCompanyStore(state => state.selectedCompany);

  const [listaConvidados, setListaConvidados] = useState<Guest[] | undefined>(
    [],
  );
  const [listaUsuariosFinal, setListaUsuariosFinal] = useState<GuestToSelect[]>(
    [],
  );
  const [listaUsuarios, setListaUsuarios] = useState<GuestToSelect[]>([]);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [isFolder, setIsFolder] = useState(false);
  const [openDropdown, setOpenDropdown] = useState<null | HTMLElement>(null);
  const [openDeleteFolderModal, setOpenDeleteFolderModal] = useState(false);
  const [openDeleteFileModal, setOpenDeleteFileModal] = useState(false);
  const [openDrawerMoving, setOpenDrawerMoving] = useState(false);
  const [openDrawerSignatures, setOpenDrawerSignatures] = useState(false);
  const [openDrawerEditLink, setOpenDrawerEditLink] = useState(false);
  const [openDrawerViewSignatures, setOpenDrawerViewSignatures] =
    useState(false);
  const [loadingBackdrop, setLoadingBackdrop] = useState({
    message: 'Carregando',
    status: false,
  });
  const [folderType, setFolderType] = useState('public');
  const [listagemPastas, setListagemPastas] = useState<any[]>([]);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [selectedArquive, setSelectedArquive] = useState<any>({});
  const [searchForUsers, setSearchForUsers] = useState('');
  const [fileId, setFileId] = useState('');
  const [fileKey, setFileKey] = useState('');
  const [selectedAll, setSelectedAll] = useState<boolean | null>(null);
  const [fileToSign, setFileToSign] = useState<any>({});
  const [fileToViewSign, setFileToViewSign] = useState<any>({});
  const [moveItemSelected, setMoveItemSelected] = useState({
    id: '',
    isFolder: false,
  });

  const isInCompany = selectedCompany?.users_ids?.find(id => id === user?.doc);

  const formValidation = useCallback((): any => {
    return Yup.object().shape({
      name: Yup.string()
        .required('O nome é obrigatório.')
        .min(3, 'O nome precisa ter no mínimo 3 caracteres'),
      link: Yup.string().nullable(),
    });
  }, []);

  const {
    control,
    handleSubmit,
    reset,
    setValue,
    formState: { isSubmitting },
  } = useForm({
    resolver: yupResolver(formValidation()),
  });

  const loadUsers = useCallback(async () => {
    try {
      const response = await getUsersByCompanyIdRequest(
        selectedCompany?.id as string,
        searchForUsers,
        '',
        '100',
        '',
      );

      setListaUsuarios(response?.data?.data);
    } catch (err) {
      console.log(err);
    }
  }, [searchForUsers, selectedCompany?.id]);

  useEffect(() => {
    loadUsers();
  }, []);

  useEffect(() => {
    const filterUser = listaUsuarios?.filter(users =>
      users.name.toUpperCase().includes(searchForUsers.toUpperCase()),
    );
    setListaUsuariosFinal(
      filterUser?.length > 0 ? filterUser : listaUsuariosFinal,
    );
  }, [searchForUsers, openEdit, openDrawerSignatures]);

  useEffect(() => {
    if (files && files?.length > 0) {
      const filesFormatted = files.map((f: any) => ({
        ...f,
        lastModification: f.updated_at
          ? dayjs(f.updated_at).format('DD/MM/YYYY')
          : dayjs(f.created_at).format('DD/MM/YYYY'),
        config: '',
      }));
      // console.log({ filesFormatted });
      setListagemPastas(filesFormatted);
    }
  }, [files]);

  useEffect(() => {
    if (openEdit) {
      setSelectedAll(null);
    }
  }, [openEdit]);

  const handleUserToInviteFolder = useCallback(
    (
      event: React.MouseEvent<unknown>,
      name: string,
      usr: GuestToSelect,
      idx: number,
      type: 'select',
    ) => {
      let listaUsuariosEditada = { ...usr };

      if (type === 'select') {
        listaUsuariosEditada.selected = !usr?.selected;
      }

      if (searchForUsers?.length > 0) {
        const listFilteredWhenSearching = listaUsuarios?.map(u => {
          if (u?.id === usr?.id) {
            setSearchForUsers('');
            return listaUsuariosEditada;
          }
          return u;
        });
        const usuariosMembros = listFilteredWhenSearching?.filter(
          u => u.selected,
        );
        setListaConvidados([...usuariosMembros!]);
        setListaUsuarios(listFilteredWhenSearching);
        setListaUsuariosFinal(listFilteredWhenSearching);
      } else {
        listaUsuarios?.splice(idx, 1, listaUsuariosEditada);
        listaUsuariosFinal?.splice(idx, 1, listaUsuariosEditada);
        setListaUsuarios([...listaUsuarios!]);
        setListaUsuariosFinal([...listaUsuariosFinal!]);
        const usuariosMembros = listaUsuarios?.filter(u => u.selected);
        setListaConvidados([...usuariosMembros!]);
      }
    },
    [listaUsuarios, listaUsuariosFinal, searchForUsers?.length],
  );

  const getFolderById = useCallback(async () => {
    try {
      setLoadingUsers(true);
      let response: any;

      if (isFolder) {
        response = await getFoldersByFolderIdRequest(
          fileId,
          user?.id as string,
        );
      } else {
        response = await getFileByIdRequest(
          fileId,
          selectedCompany?.id as string,
          user?.id as string,
        );
      }

      if (fileId) {
        const usuarios = listaUsuarios?.map((u: Guest) => ({
          ...u,
          profile: 'GS2',
          selected: false,
        }));

        const guests: any = response?.data.guests.map((u: Guest) => ({
          ...u,
          selected: true,
        }));

        const usuariosFiltrados = _.differenceBy(
          usuarios as any,
          guests as any,
          'id',
        );

        const todosUsuarios = guests?.concat(usuariosFiltrados as any);

        const guestsWithoutOwner = todosUsuarios?.filter(
          (m: any) => m.id !== user?.id,
        );

        setListaUsuariosFinal(guestsWithoutOwner as any);
        setListaUsuarios(guestsWithoutOwner);
        setListaConvidados(response?.data.guests);
        setFolderType(guests?.length > 0 ? 'private' : 'public');
        setSelectedAll(null);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingUsers(false);
    }
  }, [isFolder, fileId, user?.id, selectedCompany?.id, listaUsuarios]);

  useEffect(() => {
    if (fileId) {
      getFolderById();
    }
  }, [fileId, openEdit, openDrawerSignatures]);

  const setFolderToEdit = useCallback(
    (f: any, indx: number, type: string, event: ChangeEvent) => {
      event.stopPropagation();

      const isFoldr = type === 'folder';

      setOpenDropdown(null);
      setIsFolder(isFoldr);
      setFileId(f?.id);
      setValue('name', isFoldr ? f.name : f.original_name);
      setSelectedIndex(indx);
      setSelectedArquive(f);
      // setListaUsuarios(f?.guests);

      if (type === 'link') {
        setOpenDrawerEditLink(true);
        setValue('link', f.url);
      } else {
        setOpenEdit(true);
      }
    },
    [setValue],
  );

  const handleFile = useCallback(
    async (formData: any) => {
      setLoadingBackdrop({
        message: `${fileId ? 'Editando' : 'Criando'} ${
          isFolder ? 'Pasta' : 'Arquivo'
        }`,
        status: true,
      });
      try {
        if (user?.profile === 'UN1' || user?.profile === 'UN2') {
          const guests = listaConvidados?.map(m => ({
            id: m.id,
            name: m.name,
            email: m.email,
            avatar_url: m.avatar_url,
            profile: m.profile,
            status: m.status,
          }));

          const guestsWithOwner = guests?.concat({
            id: user?.id as string,
            name: user?.name as string,
            email: user?.email as string,
            profile: 'GS1',
            status: user?.status as 'US1' | 'US2' | 'US3',
            avatar_url: user?.avatar_url,
          });

          const guests_ids = guestsWithOwner?.map(m => m.id);

          let data = {
            [isFolder ? 'name' : 'original_name']: formData.name,
            guests: folderType === 'public' ? [] : guestsWithOwner,
            owner_id: !fileId ? user?.id : selectedArquive?.owner_id,
            guests_ids: folderType === 'public' ? [] : guests_ids,
          };

          let response: any;
          if (fileId) {
            if (isFolder) {
              response = await updateFolderRequest(
                data as any,
                fileId,
                user?.id as string,
                selectedCompany?.id as string,
              );
            } else {
              const link =
                selectedArquive.type === 'link'
                  ? formData.link
                  : selectedArquive.url;

              data = {
                ...data,
                url: link,
                key: link,
              };
              response = await updateWithoutFileRequest(
                data as any,
                fileId,
                user?.id,
                selectedCompany?.id as string,
              );
            }

            if (response.status === 200) {
              const editedFile = {
                ...selectedArquive,
                ...response?.data,
              };
              listagemPastas.splice(selectedIndex, 1, editedFile);

              setListagemPastas([...listagemPastas]);
              setFiles([...listagemPastas]);
              setSelectedAll(null);
            }
          } else {
            response = await createFolderRequest(
              data as any,
              user?.id as string,
              selectedCompany?.id as string,
              'nullFILEARQUIVE',
            );

            if (response.status === 201) {
              toast.success('Pasta criada com sucesso');
              onLoad();
              setListagemPastas([...listagemPastas, { ...response?.data }]);
              setFiles([...listagemPastas, { ...response?.data }]);
            }
          }

          reset();
          if (selectedArquive.type === 'link') {
            setOpenDrawerEditLink(false);
          } else {
            setOpenEdit(false);
          }
        } else {
          toast.warning(
            `Você não tem permissão para ${fileId ? 'editar' : 'criar'} pasta`,
          );
        }
      } catch (error) {
        console.log('Error handleFile => ', error);
      } finally {
        setLoadingBackdrop({
          message: fileId ? 'Editando Arquivo' : 'Criando Arquivo',
          status: false,
        });
      }
    },
    [
      fileId,
      isFolder,
      user?.profile,
      user?.id,
      listaConvidados,
      folderType,
      reset,
      selectedArquive,
      selectedCompany?.id,
      listagemPastas,
      selectedIndex,
      setFiles,
      onLoad,
    ],
  );

  const handleSelectedAll = () => {
    setSelectedAll(prev => !prev);
  };

  useEffect(() => {
    if (selectedAll === null) {
      const users = listaUsuarios?.map(u => ({
        ...u,
      }));

      setListaUsuarios([...users]);

      setListaUsuariosFinal([...users]);

      setListaConvidados([...users]);
    } else if (selectedAll === false) {
      const usersUnselected = listaUsuarios?.map(u => ({
        ...u,
        selected: false,
      }));
      setListaUsuarios([...usersUnselected]);
      setListaUsuariosFinal([...usersUnselected]);
      setListaConvidados([]);
    } else if (selectedAll === true) {
      const usersSelected = listaUsuarios?.map(u => ({
        ...u,
        selected: true,
      }));
      setListaUsuarios([...usersSelected]);
      setListaUsuariosFinal([...usersSelected]);
      setListaConvidados([...usersSelected]);
    }
  }, [selectedAll, openEdit, openDrawerSignatures]);

  const getLabelForAmount = () => {
    const usersSelecteds = listaUsuariosFinal?.filter(u => u?.selected);

    if (usersSelecteds?.length === 1) {
      return `${usersSelecteds?.length} selecionado`;
    }
    return `${usersSelecteds?.length} selecionados`;
  };

  const handleOpenModalRemove = useCallback(
    (file: any, isFoldr: boolean, event: ChangeEvent) => {
      event.stopPropagation();

      setFileId(file.id);

      if (isFoldr) {
        setIsFolder(isFoldr);
        setOpenDeleteFolderModal(true);
      } else {
        setFileKey(file.key);
        setOpenDeleteFileModal(true);
      }
    },
    [],
  );

  const handleOpenMoveModal = useCallback(
    (item: any, itemIsFolder: boolean, event: ChangeEvent) => {
      event.stopPropagation();

      setMoveItemSelected({
        id: item?.id,
        isFolder: itemIsFolder,
      });

      setOpenDrawerMoving(true);
    },
    [],
  );

  const handleCloseMoveModal = useCallback(() => {
    setMoveItemSelected({
      id: '',
      isFolder: false,
    });

    setOpenDrawerMoving(false);
  }, []);

  const handleMove = useCallback(
    async (item: string) => {
      const response = await moveFolder(
        moveItemSelected.id,
        item,
        moveItemSelected.isFolder,
      );

      if (response?.status === 201) {
        setMoveItemSelected({
          id: '',
          isFolder: false,
        });

        onLoad();
      }

      setOpenDrawerMoving(false);
    },
    [moveItemSelected, onLoad],
  );

  const handleRemoveFolder = useCallback(async () => {
    setLoadingBackdrop({
      message: 'Excluindo pasta',
      status: true,
    });
    try {
      if (user?.profile === 'UN1' || user?.profile === 'UN2') {
        const response = await removeFolderRequest(
          fileId,
          user?.id as string,
          selectedCompany?.id as string,
        );

        if (response?.status === 200) {
          const listFiltered = listagemPastas.filter(
            item => item.id !== fileId,
          );
          setListagemPastas(listFiltered);
          setFiles(listFiltered);
          toast.success('Pasta removida com sucesso');

          setOpenDeleteFolderModal(false);
          onLoad();
        }
      } else {
        toast.warning('Você não tem permissão para remover esta pasta');
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingBackdrop({
        message: 'Excluindo pasta',
        status: false,
      });
    }
  }, [
    fileId,
    listagemPastas,
    onLoad,
    selectedCompany?.id,
    setFiles,
    user?.id,
    user?.profile,
  ]);

  const handleRemoveFile = useCallback(async () => {
    try {
      setLoadingBackdrop({
        message: 'Excluindo arquivo',
        status: true,
      });
      setOpenDeleteFileModal(false);
      if (user?.profile === 'UN1' || user?.profile === 'UN2') {
        let response;

        if (isInFolder) {
          response = await removeFileInFolderRequest(
            params?.id as string,
            fileId,
            user?.id as string,
            selectedCompany?.id as string,
          );
        } else {
          response = await removeFileInFolderRequest(
            fileKey,
            fileId,
            user?.id as string,
            selectedCompany?.id as string,
          );
        }

        if (response?.status === 200) {
          const listFiltered = listagemPastas.filter(
            item => item.id !== fileId,
          );
          setListagemPastas(listFiltered);
          setFiles(listFiltered);
          onLoad();
          toast.success('Arquivo removido com sucesso');
        }
      } else {
        toast.warning('Você não tem permissão para remover esta pasta');
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingBackdrop({
        message: 'Excluindo arquivo',
        status: false,
      });
    }
  }, [
    user?.profile,
    user?.id,
    isInFolder,
    params?.id,
    fileId,
    selectedCompany?.id,
    fileKey,
    listagemPastas,
    setFiles,
    onLoad,
  ]);

  const drawerViewSignatures = () => (
    <DrawerSignatures
      setOpenDrawerViewSignatures={setOpenDrawerViewSignatures}
      openDrawerViewSignatures={openDrawerViewSignatures}
      fileToViewSign={fileToViewSign}
    />
  );

  const drawerRequestSignatures = () => (
    <DrawerRequestSignaturesDoc
      setOpenDrawerSignatures={setOpenDrawerSignatures}
      fileToSign={fileToSign}
      setFileId={setFileId}
      onLoad={onLoad}
    />
  );

  const drawerEditLink = () => (
    <Box
      width="480px"
      padding="20px"
      display="flex"
      flexDirection="column"
      height="100%"
    >
      <HeaderDrawer>
        <CloseRounded
          sx={{ cursor: 'pointer', position: 'absolute', left: '0' }}
          onClick={() => setOpenDrawerEditLink(false)}
        />
        <span className="title">Editar link</span>
      </HeaderDrawer>
      <Box display="flex" flexDirection="column" height="100%">
        <form
          onSubmit={handleSubmit(handleFile)}
          style={{ display: 'flex', flexDirection: 'column', height: '100%' }}
        >
          <Box display="flex" flexDirection="column" height="100%">
            <Box display="flex" flexDirection="column" height="100%">
              <Input
                label="Título ou descrição"
                name="name"
                control={control}
                placeholder="Título ou descrição"
                sx={{ marginTop: '30px' }}
                fullWidth
              />
              <Input
                label="Link externo"
                name="link"
                control={control}
                placeholder="Link externo"
                fullWidth
              />
            </Box>
            <Box width="100%" display="flex" justifyContent="end" flex="0 0 0">
              <Button
                type="submit"
                variant="contained"
                color="success"
                disabled={loadingBackdrop.status}
                sx={{
                  color: '#fff',
                  fontWeight: '500',
                  fontSize: '15px',
                  marginTop: '20px',
                }}
              >
                Salvar
              </Button>
            </Box>
          </Box>
        </form>
      </Box>
    </Box>
  );

  const drawerEditFile = () => (
    <Box
      width="480px"
      padding="20px"
      height="100%"
      display="flex"
      flexDirection="column"
    >
      <HeaderDrawer>
        <CloseRounded
          sx={{ cursor: 'pointer', position: 'absolute', left: '0' }}
          onClick={() => setOpenEdit(false)}
        />
        <span className="title">
          {fileId
            ? `Editar ${isFolder ? 'pasta' : 'arquivo'}`
            : `Criar ${isFolder ? 'pasta' : 'arquivo'}`}
        </span>
      </HeaderDrawer>
      <Box height="100%">
        <form onSubmit={handleSubmit(handleFile)} style={{ height: '100%' }}>
          <Box height="100%" display="flex" flexDirection="column">
            <Input
              label={`Nome ${isFolder ? 'da pasta' : 'do arquivo'}`}
              name="name"
              control={control}
              placeholder={`Nome ${isFolder ? 'da pasta' : 'do arquivo'}`}
              sx={{ marginTop: '30px' }}
              fullWidth
            />
            {isFolder && (
              <>
                <FolderType>
                  <FolderTypeTitle>Tipo da pasta</FolderTypeTitle>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    value={folderType}
                  >
                    <FormControlLabel
                      value="public"
                      control={<Radio />}
                      label="Pública"
                      onChange={() => setFolderType('public')}
                    />
                    <FormControlLabel
                      value="private"
                      control={<Radio />}
                      label="Compartilhar com"
                      onChange={() => setFolderType('private')}
                    />
                  </RadioGroup>
                </FolderType>

                {folderType === 'private' &&
                  (listaUsuariosFinal?.length > 0 ? (
                    <>
                      <TextField
                        variant="filled"
                        placeholder="Filtrar usuário..."
                        value={searchForUsers}
                        fullWidth
                        onChange={ev => setSearchForUsers(ev.target.value)}
                        InputProps={{
                          endAdornment: <SearchRounded />,
                        }}
                        sx={{ marginTop: '10px' }}
                      />
                      {loadingUsers ? (
                        <Box
                          width="100%"
                          display="flex"
                          justifyContent="center"
                          mt="20px"
                        >
                          <CircularProgress />
                        </Box>
                      ) : (
                        <>
                          <Box flex="1 0 0" overflow="auto" marginBottom="20px">
                            {searchForUsers?.length === 0 && (
                              <SelectedAllBtn onClick={handleSelectedAll}>
                                <Checkbox
                                  color="primary"
                                  checked={selectedAll || false}
                                  sx={{
                                    padding: '0',
                                  }}
                                />
                                <TextBtn>Selecionar todos</TextBtn>
                              </SelectedAllBtn>
                            )}
                            {listaUsuariosFinal?.map(
                              (u: any, index: number) => (
                                <Users
                                  onClick={event =>
                                    handleUserToInviteFolder(
                                      event,
                                      u.name,
                                      u,
                                      index,
                                      'select',
                                    )
                                  }
                                  key={u?.id}
                                >
                                  <Checkbox
                                    color="primary"
                                    checked={u.selected}
                                    sx={{ padding: '0' }}
                                  />
                                  <Box
                                    display="flex"
                                    flexDirection="row"
                                    gap="10px"
                                  >
                                    {u?.avatar_url ? (
                                      <Avatar sx={{ width: '40px' }}>
                                        <img
                                          src={u?.avatar_url as string}
                                          alt="Foto de perfil"
                                          style={{ width: '100%' }}
                                        />
                                      </Avatar>
                                    ) : (
                                      <Avatar
                                        {...stringAvatar(u.name!)}
                                        sx={{ width: '40px' }}
                                      />
                                    )}
                                  </Box>
                                  <span className="name">{u.name}</span>
                                </Users>
                              ),
                            )}
                          </Box>
                        </>
                      )}
                    </>
                  ) : (
                    <Box marginTop="10px" flex="1 0 0">
                      Não há nenhum usuário convidado para adicionar
                    </Box>
                  ))}
              </>
            )}
            <Box
              width="100%"
              display="flex"
              justifyContent="end"
              flex={folderType === 'private' ? '0 0 0' : '1 0 0'}
              alignItems={folderType === 'private' ? 'center' : 'flex-end'}
              gap="10px"
            >
              {folderType === 'private' && (
                <AmountSelectedUsers>{getLabelForAmount()}</AmountSelectedUsers>
              )}
              <Button
                type="submit"
                variant="contained"
                color="success"
                disabled={isSubmitting || !isInCompany}
                sx={{
                  color: '#fff',
                  fontWeight: '500',
                  fontSize: '15px',
                }}
              >
                Salvar
              </Button>
            </Box>
          </Box>
        </form>
      </Box>
    </Box>
  );

  const drawerMoving = () => (
    <MovingFile
      files={listagemPastas}
      setOpenDrawerMoving={handleCloseMoveModal}
      folderId={params?.id ? params?.id : 'null'}
      handleMove={handleMove}
      moveItemSelected={moveItemSelected}
    />
  );

  const handleSignatureDrawer = (
    file: any,
    isFoldr: boolean,
    event: ChangeEvent,
  ) => {
    event.stopPropagation();
    setOpenDropdown(null);
    setFileToSign(file);
    setOpenDrawerSignatures(true);
  };

  const handleViewSignatureDrawer = (
    file: any,
    isFoldr: boolean,
    event: ChangeEvent,
  ) => {
    event.stopPropagation();
    setOpenDropdown(null);
    setFileToViewSign(file);
    setOpenDrawerViewSignatures(true);
  };

  const getArquiveComponent = (item: any, index: number) => {
    switch (item.type) {
      case 'folder':
        return (
          <FolderCard
            folder={item}
            folderIndex={index}
            handleOpenModalRemove={handleOpenModalRemove}
            handleOpenEditDrawer={setFolderToEdit}
            handleOpenMoveModal={handleOpenMoveModal}
            ownerName={item?.owner?.name as string}
            handleOpenFileViewer={handleOpenFileViewer}
            isFolder
            isAutomatic={isAutomatic}
          />
        );

      case 'file':
        return (
          <FolderCard
            folder={item}
            folderIndex={index}
            handleOpenModalRemove={handleOpenModalRemove}
            handleOpenEditDrawer={setFolderToEdit}
            handleSignatureDrawer={handleSignatureDrawer}
            handleViewSignatureDrawer={handleViewSignatureDrawer}
            handleOpenMoveModal={handleOpenMoveModal}
            ownerName={item?.owner?.name as string}
            handleOpenFileViewer={handleOpenFileViewer}
            isAutomatic={isAutomatic}
          />
        );

      default:
        return (
          <FolderCard
            folder={item}
            folderIndex={index}
            handleOpenModalRemove={handleOpenModalRemove}
            handleOpenEditDrawer={setFolderToEdit}
            handleOpenMoveModal={handleOpenMoveModal}
            ownerName={item?.owner?.name as string}
            handleOpenFileViewer={() => ({})}
            isAutomatic={isAutomatic}
          />
        );
    }
  };

  return (
    <Container>
      {loadingBackdrop && (
        <LoadingBackdrop
          text={loadingBackdrop.message}
          component=""
          loading={loadingBackdrop.status}
        />
      )}
      <ArchiveStyles>
        <Box
          sx={{
            padding: 0,
            display: 'flex',
            width: '100%',
            flexDirection: 'column',
            margin: 0,
            gap: '10px',
          }}
        >
          {listagemPastas?.map((archive, index) =>
            getArquiveComponent(archive, index),
          )}
        </Box>
      </ArchiveStyles>
      <ConfirmModal
        open={openDeleteFolderModal}
        onClose={() => setOpenDeleteFolderModal(false)}
        title="Deletar pasta"
        subtitle="A pasta será removido permanentemente, deseja continuar?"
        btnTextCancel="CANCELAR"
        btnTextConfirm="confirmar"
        type="error"
        onCancel={() => setOpenDeleteFolderModal(false)}
        onConfirm={() => handleRemoveFolder()}
      />
      <ConfirmModal
        open={openDeleteFileModal}
        onClose={() => setOpenDeleteFileModal(false)}
        title="Deletar aquivo"
        subtitle="O arquivo será removido permanentemente, deseja continuar?"
        btnTextCancel="CANCELAR"
        btnTextConfirm="confirmar"
        type="error"
        onCancel={() => setOpenDeleteFileModal(false)}
        onConfirm={() => handleRemoveFile()}
      />
      <SwipeableDrawer
        onClose={() => setOpenEdit(false)}
        onOpen={() => setOpenEdit(true)}
        open={openEdit}
        anchor="right"
      >
        {drawerEditFile()}
      </SwipeableDrawer>
      <SwipeableDrawer
        anchor="right"
        open={openDrawerSignatures}
        onClose={() => setOpenDrawerSignatures(true)}
        onOpen={() => setOpenDrawerSignatures(true)}
        ModalProps={{
          keepMounted: true,
        }}
      >
        {drawerRequestSignatures()}
      </SwipeableDrawer>
      <SwipeableDrawer
        anchor="right"
        open={openDrawerViewSignatures}
        onClose={() => setOpenDrawerViewSignatures(false)}
        onOpen={() => setOpenDrawerViewSignatures(true)}
        ModalProps={{
          keepMounted: true,
        }}
      >
        {drawerViewSignatures()}
      </SwipeableDrawer>
      <SwipeableDrawer
        anchor="right"
        open={openDrawerMoving}
        onClose={handleCloseMoveModal}
        onOpen={() => setOpenDrawerMoving(true)}
        ModalProps={{
          keepMounted: true,
        }}
      >
        {drawerMoving()}
      </SwipeableDrawer>
      <SwipeableDrawer
        onClose={() => setOpenDrawerEditLink(false)}
        onOpen={() => setOpenDrawerEditLink(true)}
        open={openDrawerEditLink}
        anchor="right"
      >
        {drawerEditLink()}
      </SwipeableDrawer>
    </Container>
  );
};
